module.exports = __webpack_public_path__ + "img/Left_rotation.da9984f2.png";